/**
 * @file Provides MobizCommonCoreModule.
 */
import { ModuleWithProviders, NgModule, Provider } from '../injection';

import { API_ENDPOINT_INFORMATION_RECORDS } from './interfaces/api-endpoint-information.interface';
import { LOG_HANDLER, LoggerService } from './logger/logger.service';
import { WebConsoleLogHandlerService } from './logger/web-console-log-handler.service';
import { API_ENDPOINT_INFORMATION_RECORDS_VALUE } from './other/mobiz-server-api.enum';
import { IAccountService } from './services/account.interface';
import { AccountService } from './services/account.service';
import { IAdminDomainService } from './services/admin-domain.interface';
import { AdminDomainService } from './services/admin-domain.service';
import { IAuthTokenService } from './services/auth-token.interface';
import { IAuthService } from './services/auth.interface';
import { AuthService } from './services/auth.service';
import { ConnectionStateService } from './services/connection-state.service';
import { IInviteService } from './services/invite.interface';
import { InviteService } from './services/invite.service';
import { IMembershipService } from './services/membership.interface';
import { MembershipService } from './services/membership.service';
import { IMobizContextService } from './services/mobiz-context.interface';
import { MobizContextService } from './services/mobiz-context.service';
import { IMobizExtensionService } from './services/mobiz-extension.interface';
import { MobizExtensionService } from './services/mobiz-extension.service';
import { MobizServerApiBuilderService } from './services/mobiz-server-api-builder.service';
import { IMobizStateService } from './services/mobiz-state.interface';
import { MobizStateService } from './services/mobiz-state.service';
import { IMobizStorageService } from './services/mobiz-storage.interface';
import { MobizStorageService } from './services/mobiz-storage.service';
import { OAuth2TokenService } from './services/oauth2-token.service';
import { IOrganizationService } from './services/organization.interface';
import { OrganizationService } from './services/organization.service';
import { ISecurityService } from './services/security.interface';
import { SecurityService } from './services/security.service';
import { IServerApiBuilderService } from './services/server-api-builder.interface';
import { IStringTemplateService } from './services/string-template.interface';
import { StringTemplateService } from './services/string-template.service';
import { IUserService } from './services/user.interface';
import { UserService } from './services/user.service';

@NgModule({
  declarations: [],
  exports: [],
  imports: [],
})
export class MobizCommonCoreModule {
  public static readonly PROVIDERS: Provider[] = [
    ConnectionStateService,
    LoggerService,
    {
      multi: true,
      provide: LOG_HANDLER,
      useClass: WebConsoleLogHandlerService,
    },
    {
      multi: true,
      provide: API_ENDPOINT_INFORMATION_RECORDS,
      useValue: API_ENDPOINT_INFORMATION_RECORDS_VALUE,
    },
    {
      provide: IAccountService,
      useClass: AccountService,
    },
    {
      provide: IAdminDomainService,
      useClass: AdminDomainService,
    },
    {
      provide: IAuthService,
      useClass: AuthService,
    },
    {
      provide: IAuthTokenService,
      useClass: OAuth2TokenService,
    },
    {
      provide: IInviteService,
      useClass: InviteService,
    },
    {
      provide: IMembershipService,
      useClass: MembershipService,
    },
    {
      provide: IMobizContextService,
      useClass: MobizContextService,
    },
    {
      provide: IMobizStateService,
      useClass: MobizStateService,
    },
    {
      provide: IMobizStorageService,
      useClass: MobizStorageService,
    },
    {
      provide: IOrganizationService,
      useClass: OrganizationService,
    },
    {
      provide: IServerApiBuilderService,
      useClass: MobizServerApiBuilderService,
    },
    {
      provide: IStringTemplateService,
      useClass: StringTemplateService,
    },
    {
      provide: IUserService,
      useClass: UserService,
    },
    {
      provide: ISecurityService,
      useClass: SecurityService,
    },
    {
      provide: IMobizExtensionService,
      useClass: MobizExtensionService,
    },
  ];

  /**
   * Returns the module along with its dependent providers.
   */
  public static forRoot(): ModuleWithProviders<MobizCommonCoreModule> {
    return {
      ngModule: MobizCommonCoreModule,
      providers: MobizCommonCoreModule.PROVIDERS,
    };
  }
}
